import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_DOMAINS_PRODUCT_ENABLED: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateDomainsProductEnabled($input: UpdateDomainsProductEnabledInput!) {
    updateDomainsProductEnabled(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
